<template>
  <!--srccomponentsrectCardindexvuehtmlStart-->

  <div id="defaultId1">
    <div id="gd41bb" class="u1dc85">
      <div id="g35a23" :style="{ backgroundColor: value.color }" class="ud86f5">
        <slot id="g803e6" class="ua68b1" name="icon"> </slot>
      </div>
      <!-- <div id="g4ddec" class="u8dc3b">
        
            </div> -->

      <div id="g3d7e9" class="u1e6ea">
        <div id="g05a8b" class="u5311d">
          <!-- 公司详情接口 -->
          <!-- <p>{{ value.title }}</p> -->
          <!-- :style="{ color: value.color }" -->
          <span id="g61e77" class="u4856e">{{ value.title }} </span>
        </div>
        <!-- v-show="value.textColor!='-'"  -->
        <div
          class="avtiveColor margin-bottom30"
          :style="{ color: textColor(value.textColor) }"
        >
          {{ value.status == "-" ? "" : value.status }}
        </div>
      </div>
      <div id="gf214a" class="ua367f">
        <slot id="g803e6" class="ua68b1"> </slot>
      </div>
    </div>
  </div>
  <!--srccomponentsrectCardindexvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart

import textContent from "../text_content/index.vue";
//importEnd

export default {
  name: "",

  props: {
    // srccomponentsrectCardindexvuePropsStart

    // srccomponentsrectCardindexvuePropsEnd

    value: {
      type: Object,
      default: {},
    },
  },

  mounted() {
    // defaultLoad
    // srccomponentsrectCardindexvueMountedStart
    // srccomponentsrectCardindexvueMountedEnd
  },

  components: {
    textContent,
  },
  computed: {},
  data() {
    return {
      // insertData
      // srccomponentsrectCardindexvueDataStart
      // srccomponentsrectCardindexvueDataEnd
    };
  },
  methods: {
    textColor(value) {
      if (value == "红") return "#F00000";
      else if (value == "黄") {
        return "#FFC000";
      } else if (value == "绿") {
        return "#00C924";
      } else if (value == "灰") {
        return "#666666";
      } else {
        return "#1A2332";
      }

      //   return this.status === 'green' ? 'green' : 'black';
    },

    houershow() {
      this.$emit("houershow", true);
    },
    houerfalse() {
      this.$emit("houershow", false);
    },

    // srccomponentsrectCardindexvueMethodEnd
  },
};
</script>
<style>
.srccomponentsrectCardindexvuecssStart {
}

.u1dc85 {
  display: flex;
  background-image: url("../../assets/images/card.png");
  background-position-y: 0;
  background-position-x: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  flex-direction: column;
}

.u8dc3b {
  display: inline-block;
  margin-top: 66px;
  margin-left: 44px;
}

.uab2Spu {
  display: inline-block;
}

.uab2Spu:hover .uAXSGHp {
  -webkit-line-clamp: auto !important;
  /* 限制为两行 */
}

.u1e6ea {
  display: flex;
  justify-content: center;
  border-style: none;
  margin: auto;
  flex-direction: column;
}

.ud86f5 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  margin-left: 28px;
  margin-top: 24px;
  flex-direction: row;
  border-radius: 50%;
}

.ua68b1 {
  margin: auto;
}

.u5311d {
  width: 300px;
  margin-top: 0px;
  margin-bottom: 16px;
  text-align: center;
}

.u4856e {
  font-family: "Arial Bold";
  font-size: 26px;
  line-height: 28px;
  color: #1a2332;
}

.ua367f {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  height: auto;
  flex-direction: column;
  /* margin-right: 2em;
        margin-left: 2em; */
  flex: auto;
  margin-left: 34px;
  margin-right: 34px;
  padding-bottom: 26px;
}

.avtiveColor {
  display: flex;
  width: 300px;
  height: 24px;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
}

.srccomponentsrectCardindexvuecssEnd {
}

@media screen and (max-width: 1920px) {
  .u8dc3b {
    margin-top: 50px;
    margin-left: 34px;
  }

  .ud86f5 {
    width: 46px;
    height: 46px;
    margin-left: 35px;
    margin-top: 27px;
  }

  .u5311d {
    width: 226px;
    margin-bottom: 12px;
  }

  .u4856e {
    font-size: 20px !important;
    line-height: 22px;
  }

  .ua367f {
    margin-left: 35px;
    margin-right: 35px;
    padding-bottom: 20px;
  }

  .avtiveColor {
    width: 226px;
    height: 18px;
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (max-width: 1439px) {
  .u8dc3b {
    margin-top: 44px;
    margin-left: 30px;
  }

  .ud86f5 {
    width: 40px;
    height: 40px;
    margin-left: 18px;
    margin-top: 16px;
  }

  .u5311d {
    width: 200px;
    margin-bottom: 10px;
  }

  .u4856e {
    font-size: 18px !important;
    line-height: 20px;
  }

  .ua367f {
    margin-left: 22px;
    margin-right: 22px;
    padding-bottom: 18px;
  }

  .avtiveColor {
    width: 200px;
    height: 16px;
    font-size: 14px;
    line-height: 18px;
  }
}
</style>
